import { Tabs } from '@mui/material'
import BoxWithBackground from '../container/BoxWithBackground'

const ToggleTabs = ({ activeTab, setActiveTab, children, ...otherProps }) => {
  return (
    <BoxWithBackground
      padding={2}
      borderRadius={3}
      overflow='visible'
      {...otherProps}>
      <Tabs
        sx={{
          '& .MuiTabs-indicator': {
            display: 'none'
          },
          '& .MuiTabs-scroller': {
            overflow: 'visible!important'
          },
          '& .MuiTabs-flexContainer': {
            overflow: 'visible',
            overflowX: 'visible'
          },
          minHeight: 0,
          width: 'max-content',
          overflow: 'visible',
          '& .MuiTab-root': {
            borderRadius: 2,
            padding: '8px 12px',
            fontSize: 14,
            overflow: 'visible',
            minHeight: 0,
            '&:hover': {
              boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.20)'
            }
          },
          '& .Mui-selected': {
            backgroundColor: 'white',
            boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.20)'
          }
        }}
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}>
        {children}
      </Tabs>
    </BoxWithBackground>
  )
}

export default ToggleTabs
